import { render, staticRenderFns } from "./DepositModal.vue?vue&type=template&id=1a030051&scoped=true&"
import script from "./DepositModal.vue?vue&type=script&lang=js&"
export * from "./DepositModal.vue?vue&type=script&lang=js&"
import style0 from "./DepositModal.vue?vue&type=style&index=0&id=1a030051&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a030051",
  null
  
)

export default component.exports